import { authModule } from "./auth/auth-module";

// Modules to register on the Vuex
export const modules = {
  auth: authModule,
};

// Modules to persist cross sessions
export const toPersist = ["auth"];
